//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        collName: String,
        columnDefs: Array,
        postSaveFn: Function,
        ops: String,
        filterArray: Array,
        filterFn: Function,
        hidePagination: Boolean,
        confirmDialogProps: Object,
        rowClick: {
            type: [Boolean, Function],
            default: true,
        },
    },

    data() {
        return {
            isLoaded: false,
        };
    },

    computed: {
        detailName() {
            return types[this.collName].pageName;
        },
        items() {
            let items = $[this.collName];

            if (this.filterArray) {
                if (typeof this.filterArray[0] === 'number') {
                    items = items.filter(i => this.filterArray.includes(i.id));
                } else {
                    items = this.filterArray;
                }
            }

            if (this.filterFn) {
                items = items.filter(this.filterFn);
            }

            return items;
        },
        bodyCellSlots() {
            return _.pickBy(this.$scopedSlots, (_, slot) => slot.startsWith('body-cell-'));
        },
        columnDefs_() {
            return [
                ...($.getSetting('injectIdColumn') ? [['id', true, null, null, null, true]] : []),
                ...this.columnDefs,
            ];
        },
        columns() {
            return [
                ...this.columnDefs_.map(([name, sortable, type, fieldFn, cellType, autoWidth, align]) => ({
                    name,
                    label: this.getLabel(name),
                    field: this.getField(name, type, fieldFn, cellType),
                    align: align || 'left',
                    sortable,
                    sort: this.getSortFn(name, type, fieldFn, cellType),
                    cellType,
                    autoWidth,
                })),
                ...[
                    'archive',
                    'destroy',
                    'remove',
                    'detail',
                ].filter(op => this.ops.includes(op)).map(op => ({ name: op })),
            ];
        },
    },

    methods: {
        getLabel(name) {
            return $.getFieldLabel(this.collName, name, ['master', 'long']);
        },
        getField(name, type, fieldFn, cellType) {
            return row => {
                const value = this.getRawValue(row, name, fieldFn);

                if (cellType === 'big-small') {
                    const types = type.includes('|') ? type.split('|') : [type, type];

                    return value.map((v, idx) => this.getFormattedValue(name, types[idx], row, v) || '-');
                }

                return this.getFormattedValue(name, type, row, value) || '-';
            };
        },
        getRawValue(row, name, fieldFn) {
            return fieldFn ? fieldFn(row) : $.get(row, name);
        },
        getFormattedValue(name, type, row, value) {
            switch (type) {
                case 'select':
                    return $.getSelectOptionLabel(this.collName, name, $.get(row, name));

                case 'datetime':
                    return $.formatDateTime(value);

                case 'date':
                    return $.formatDate(value);

                case 'boolean':
                    return this.$t(value ? 'yes' : 'no').toLowerCase();

                case 'number': {
                    const unit = $.getFieldUnit(this.collName, name, $.get(row, name));

                    return (value && unit) ? `${value} ${unit}` : value;
                }

                case 'tel':
                    return [
                        value.slice(0, -9),
                        value.slice(-9, -6),
                        value.slice(-6, -3),
                        value.slice(-3),
                    ].filter(v => v).join(' ');

                default:
                    return value;
            }
        },
        getSortFn(name, type, fieldFn, cellType) {
            if (cellType === 'big-small')
                return (a, b) => this.compareRawValues(a[0], b[0]) || this.compareRawValues(a[1], b[1]);

            return (a, b, rowA, rowB) => this.compareRawValues(
                this.getRawValue(rowA, name, fieldFn),
                this.getRawValue(rowB, name, fieldFn),
            );
        },
        compareRawValues(a, b) {
            return (typeof a === 'number')
                ? a - b
                : `${a}`.localeCompare(`${b}`, 'cs');
        },
        async archive(item) {
            if (!(await $.safeArchiveOne(this.collName, item, true)))
                return;

            if (this.postSaveFn) {
                await this.postSaveFn(item, 'archive');
            }

            notifyOk("Smazání proběhlo úspěšně.");
        },
        async restore(item) {
            if (!(await $.safeRestoreOne(this.collName, item, true)))
                return;

            if (this.postSaveFn) {
                await this.postSaveFn(item, 'restore');
            }

            notifyOk("Obnovení proběhlo úspěšně.");
        },
        async destroy(item) {
            if (!(await $.safeDestroyOne(this.collName, item)))
                return;

            notifyOk("Trvalé smazání proběhlo úspěšně.");
        },
        onRowClick(ev, row) {
            if (typeof this.rowClick === 'function') {
                this.rowClick(ev, row);
            } else {
                $.goToDetail(this.detailName, row.id);
            }
        },
    },

    @cancellableFetch
    async mounted() {
        await $.actualizeAndFetch(this.collName);

        this.isLoaded = true;
    },
};
